export const examsPdfs = {
    "State Board": {
    
    },
  };
  